import { h } from "preact";
import { useCurrentDay } from "../../hooks";
import { getWeek, MonthModel, range, weekdayLetters } from "./common";

interface MultiMonthCalendarProps {
    months: MonthModel[];
    onMonthSelected?: (month: MonthModel) => void;
    onWeekSelected?: (firstDayInWeek: Date) => void;
    onDaySelected?: (date: Date) => void;
}

export function MultiMonthCalendar(props: MultiMonthCalendarProps) {
    return (
        <div class="calendar  calendar-multimonth">
            {
                props.months.map(month => <MonthColumn month={month} onMonthSelected={props.onMonthSelected} onWeekSelected={props.onWeekSelected} onDaySelected={props.onDaySelected} />)
            }
        </div>
    );
}

function MonthColumn(props: { month: MonthModel, onMonthSelected?: (month: MonthModel) => void, onWeekSelected?: (firstDayInWeek: Date) => void, onDaySelected?: (date: Date) => void }) {
    const { firstDate, weekOfFirstDate, daysInMonth } = props.month;
    const name = firstDate.toLocaleString('default', { month: 'long' });
    const startWeekDay = firstDate.getDay();
    const today = useCurrentDay();
    const isCurrentMonth = today.year === firstDate.getFullYear() && today.month === firstDate.getMonth();

    return (
        <div class="column">
            <a class="header" onClick={() => { props.onMonthSelected && props.onMonthSelected(props.month); }}>
                {name}
                {
                // firstDate.getFullYear()
                }
            </a>
            {
                range(daysInMonth).map(day => {
                    let date = new Date(firstDate.getFullYear(), firstDate.getMonth(), day + 1);
                    let weekDay = (startWeekDay + day) % 7;
                    let letter = weekdayLetters[weekDay];
                    let week = getWeek(date);
                    let isToday = isCurrentMonth && today.day === (day + 1);
                    return (
                        <div class={(isToday ? "today" : "") + (weekDay == 0 ? " sunday" : weekDay == 6 ? " saturday" : "")} onClick={() => { props.onDaySelected && props.onDaySelected(date); }}>
                            <span>
                                <span>{letter}</span>
                                <span>{day + 1}</span>
                            </span>
                            {
                                weekDay == 1 && <span class="week" onClick={e => { e.cancelBubble = true; props.onWeekSelected && props.onWeekSelected(date); }}>{week}</span>
                            }
                        </div>
                    );
                })
            }
            {
                range(31 - daysInMonth).map(n =>
                    // todo: extra style if the month next to it has the day or doesnt
                    <div class="empty" />
                )
            }
        </div>
    );
}
